import { codeEnums } from '@/shared/utils/platform';
import { RouterH5Enum, RouterV2Enum } from '@/router/router-names';
import { PreApplyPageTypeEnum } from './types';

/** 当前页面的埋点配置，需要区别普通用户和自营升级用户 */
export const trackConfig = {
  [PreApplyPageTypeEnum.dcHalf]: {
    exposeName: 'finance_dcHalfApply_agreement',
    btnName: 'finance_dcHalfApply_contractconfirm',
    agreementClick: 'finance_dcAgreementClick',
    exposeAgreement: 'finance_dcAgreementClickFirst',
  },
  [PreApplyPageTypeEnum.normal]: {
    exposeName: 'finance_applyDeposit_agreement',
    btnName: 'finance_applyDeposit_acceptagreement',
    agreementClick: 'finance_agreementClick',
    exposeAgreement: 'finance_agreementClickFirst',
  },
  [PreApplyPageTypeEnum.autarky]: {
    exposeName: 'finance_upgradeAAppling_contract',
    btnName: 'finance_upgradeAAppling_contractconfirm',
    agreementClick: 'finance_agreementClick',
    exposeAgreement: 'finance_agreementClickFirst',
  },
};

/** 无授信渠道时， 浏览器环境 -> 页面 配置 */
export const noChannelResultMap: Map<number, string> = new Map([
  [0, `${RouterH5Enum.home}?source=lb_nopass`],
  [codeEnums.alipayMini, `${RouterV2Enum.guideDownload}`],
  [codeEnums.DingH5, `${RouterV2Enum.guideDownload}`],
]);
